import { createContext, Dispatch } from 'react';
import { ReportFilters, ViewMode } from '../../models/reports';

export const ReportsFiltersContext = createContext<ReportFilters | null>(null);
export const ReportsFiltersDispatchContext = createContext<
  Dispatch<Partial<ReportFilters> | null>
>(() => null);

export type ReportsViewModeContextData = [
  viewMode: ViewMode,
  setViewMode: Dispatch<React.SetStateAction<ViewMode>>
];

const defaultViewModeContext: ReportsViewModeContextData = [
  ViewMode.PROJECT,
  () => null,
];
export const ReportsViewModeContext = createContext<ReportsViewModeContextData>(
  defaultViewModeContext
);
